import { h } from 'preact';

const Backdrop = ({ isOpen, setIsOpen }) => (
  <div
    className={`w-full h-full fixed left-0 top-0 " ${
      isOpen ? 'opacity-100 z-[60] bg-black/60' : 'opacity-0 -z-1'
    }`}
    onClick={() => {
      document.body.style.overflow = '';
      setIsOpen(false);
    }}
  />
);

export default Backdrop;
